// extracted by mini-css-extract-plugin
export default {"tabPanel":"TabPanel-module_tabPanel__StkPF","selected":"TabPanel-module_selected__cmH1O"};